import React, { useState, useEffect } from 'react';
import { apiService } from '../../services/api';
import styles from './EditOfferModal.module.css';

const EditOfferModal = ({ open, onClose, offer, onSave, type }) => {
  const [form, setForm] = useState({
    product_id: offer?.id ?? '',
    is_featured: offer?.is_featured ?? false,
    is_prime: offer?.is_prime ?? false,
    original_price: offer?.original_price ?? '',
    cost_price: offer?.cost_price ?? '',
  });
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadProducts = async () => {
      try {
        setLoading(true);
        const response = await apiService.getProducts({ limit: 1000 });
        setProducts(response.products || []);
      } catch (error) {
        console.error('Error cargando productos:', error);
      } finally {
        setLoading(false);
      }
    };
    
    if (open) {
      loadProducts();
    }
  }, [open]);

  useEffect(() => {
    if (offer) {
      setForm({
        product_id: offer.id ?? '',
        is_featured: offer.is_featured ?? false,
        is_prime: offer.is_prime ?? false,
        original_price: offer.original_price ?? '',
        cost_price: offer.cost_price ?? '',
      });
    } else {
      setForm({
        product_id: '',
        is_featured: false,
        is_prime: false,
        original_price: '',
        cost_price: '',
      });
    }
  }, [offer]);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setForm({
      ...form,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.product_id) {
      alert('Por favor selecciona un producto');
      return;
    }
    if (onSave) onSave(form);
    if (onClose) onClose();
  };

  if (!open) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2> {type} Oferta</h2>
        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.fieldGroup}>
            <label>
              Seleccionar Producto
              <select
                name="product_id"
                value={form.product_id}
                onChange={handleChange}
                disabled={loading || !!offer}
              >
                <option value="">-- Elige un producto --</option>
                {products.map(product => (
                  <option key={product.id} value={product.id}>
                    {product.name} - ${product.price}
                  </option>
                ))}
              </select>
            </label>
          </div>
          
          <div className={styles.checkboxGroup}>
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                name="is_featured"
                checked={form.is_featured}
                onChange={handleChange}
              />
              <span>Destacado</span>
            </label>
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                name="is_prime"
                checked={form.is_prime}
                onChange={handleChange}
              />
              <span>Prime</span>
            </label>
          </div>

          <div className={styles.priceGroup}>
            <label>
              Precio Original
              <input
                type="number"
                name="original_price"
                value={form.original_price}
                onChange={handleChange}
                step="0.01"
                min="0"
              />
            </label>
            <label>
              Precio de Costo
              <input
                type="number"
                name="cost_price"
                value={form.cost_price}
                onChange={handleChange}
                step="0.01"
                min="0"
              />
            </label>
          </div>

          <div className={styles.actions}>
            <button type="submit" className={styles.saveBtn} disabled={loading}>
              {loading ? 'Cargando...' : 'Guardar'}
            </button>
            <button type="button" className={styles.cancelBtn} onClick={onClose}>Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditOfferModal;
